import base_http from './user';

const http = function (args) {
  const instance = base_http(args);

  return Object.assign({}, instance, {
    getBaseUrl: function () {
      const host = window.location.host;
      const subdomain = this.user.subdomain || 'user';

      // For staging environment
      if (host.includes('vintanalabs.com')) {
        return `${window.location.protocol}//staging-${subdomain}-invoice-gateway.vintanalabs.com/taxpayer_api`;
      }

      // For local IP-based development
      if (host === '127.0.0.1' || host === 'localhost') {
        return `${window.location.protocol}//${host}/taxpayer_api`;
      }

      // For local domain-based development
      return `${window.location.protocol}//${subdomain}.invoice-gateway.test/taxpayer_api`;
    },
  });
};

export default http;
